import React from "react";
import {
  Box, TextField, Typography, Button, IconButton,
  FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const row = { display: "grid", gridTemplateColumns: "1fr auto", gap: 8, marginBottom: 8 };

const TermsEditor = ({ value, onChange }) => {
  const v = value || {
    format: "terms.v1",
    intro: "",
    links: { privacy: { label: "", href: "", target: "_self" } },
    secoes: {
      introducao: { tipo: "text", texto: "" },
      aceitacao: { tipo: "text", texto: "" },
      conta: { tipo: "list", itens: [] },
      pagamentos: { tipo: "list", itens: [] },
      entregas: { tipo: "text", texto: "" },
      trocas: { tipo: "list", itens: [] },
      garantias: { tipo: "text", texto: "" },
      propriedade: { tipo: "text", texto: "" },
      uso: { tipo: "list", itens: [] },
      privacidade: { tipo: "text", texto: "" },
      comunicacoes: { tipo: "text", texto: "" },
      responsabilidade: { tipo: "text", texto: "" },
      indenizacao: { tipo: "text", texto: "" },
      modificacoes: { tipo: "text", texto: "" },
      rescisao: { tipo: "text", texto: "" },
      gerais: { tipo: "list", itens: [] },
      foro: { tipo: "text", texto: "", contato: { email: "", phone: "" } },
    },
    disclaimer: "",
  };

  const set = (patch) => onChange({ ...v, ...patch });

  const setSecText = (key, texto) =>
    set({ secoes: { ...v.secoes, [key]: { ...(v.secoes?.[key] || {}), tipo: "text", texto } } });

  const addList = (key) => {
    const itens = [ ...((v.secoes?.[key]?.itens) || []), "" ];
    set({ secoes: { ...v.secoes, [key]: { tipo: "list", itens } } });
  };
  const setList = (key, i, text) => {
    const itens = [ ...((v.secoes?.[key]?.itens) || []) ];
    itens[i] = text;
    set({ secoes: { ...v.secoes, [key]: { tipo: "list", itens } } });
  };
  const remList = (key, i) => {
    const itens = (v.secoes?.[key]?.itens || []).filter((_, idx) => idx !== i);
    set({ secoes: { ...v.secoes, [key]: { tipo: "list", itens } } });
  };

  return (
    <Box sx={{ display: "grid", gap: 16 }}>
      <div>
        <Typography variant="subtitle1">Termos (terms.v1)</Typography>
        <TextField
          label="Parágrafo inicial (antes do sumário)"
          value={v.intro || ""}
          onChange={(e)=>set({ intro: e.target.value })}
          fullWidth multiline minRows={3} sx={{ mt: 1 }}
        />
      </div>

      {/* Link para Política de Privacidade (opcional) */}
      <div>
        <Typography variant="subtitle2">Link para Política de Privacidade (opcional)</Typography>
        <Box sx={{ display:"grid", gridTemplateColumns:"2fr 3fr 1fr", gap: 8, mt: 1 }}>
          <TextField
            label="Rótulo"
            value={v.links?.privacy?.label || ""}
            onChange={(e)=>set({ links:{ ...v.links, privacy:{ ...(v.links?.privacy||{}), label:e.target.value } } })}
          />
          <TextField
            label="URL"
            value={v.links?.privacy?.href || ""}
            onChange={(e)=>set({ links:{ ...v.links, privacy:{ ...(v.links?.privacy||{}), href:e.target.value } } })}
          />
          <FormControl>
            <InputLabel>Target</InputLabel>
            <Select
              label="Target"
              value={v.links?.privacy?.target || "_self"}
              onChange={(e)=>set({ links:{ ...v.links, privacy:{ ...(v.links?.privacy||{}), target: e.target.value } } })}
            >
              <MenuItem value="_self">_self</MenuItem>
              <MenuItem value="_blank">_blank</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>

      {/* Seções de texto */}
      {[
        ["introducao","1) Introdução"],
        ["aceitacao","2) Aceitação dos Termos"],
        ["entregas","5) Entregas e Prazos"],
        ["garantias","7) Garantias e Assistência"],
        ["propriedade","8) Propriedade Intelectual"],
        ["privacidade","10) Privacidade e Dados Pessoais"],
        ["comunicacoes","11) Comunicações"],
        ["responsabilidade","12) Limitação de Responsabilidade"],
        ["indenizacao","13) Indenização"],
        ["modificacoes","14) Modificações destes Termos"],
        ["rescisao","15) Rescisão"],
        ["foro","17) Foro e Legislação Aplicável"],
      ].map(([key,label])=>(
        <Box key={key}>
          <Typography variant="subtitle2">{label}</Typography>
          <TextField
            label="Texto"
            value={v.secoes?.[key]?.texto || ""}
            onChange={(e)=>setSecText(key, e.target.value)}
            fullWidth multiline minRows={3} sx={{ mt: 1 }}
          />
          {key==="foro" && (
            <Box sx={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap: 8, mt: 1 }}>
              <TextField
                label="E-mail de contato"
                value={v.secoes?.foro?.contato?.email || ""}
                onChange={(e)=>set({ secoes:{ ...v.secoes, foro:{ ...v.secoes.foro, contato:{ ...(v.secoes.foro?.contato||{}), email:e.target.value } } } })}
              />
              <TextField
                label="Telefone"
                value={v.secoes?.foro?.contato?.phone || ""}
                onChange={(e)=>set({ secoes:{ ...v.secoes, foro:{ ...v.secoes.foro, contato:{ ...(v.secoes.foro?.contato||{}), phone:e.target.value } } } })}
              />
            </Box>
          )}
        </Box>
      ))}

      {/* Seções de lista */}
      {[
        ["conta","3) Cadastro e Conta"],
        ["pagamentos","4) Compras e Pagamentos"],
        ["trocas","6) Trocas, Devoluções e Arrependimento"],
        ["uso","9) Uso do Site e Condutas Proibidas"],
        ["gerais","16) Disposições Gerais"],
      ].map(([key,label])=>(
        <Box key={key}>
          <Typography variant="subtitle2">{label}</Typography>
          {(v.secoes?.[key]?.itens || []).map((t, i)=>(
            <Box key={`${key}-${i}`} sx={row}>
              <TextField value={t} onChange={(e)=>setList(key, i, e.target.value)} fullWidth />
              <IconButton onClick={()=>remList(key, i)}><DeleteOutlineRoundedIcon /></IconButton>
            </Box>
          ))}
          <Button startIcon={<AddRoundedIcon />} onClick={()=>addList(key)}>Adicionar item</Button>
        </Box>
      ))}

      {/* Rodapé/observação */}
      <div>
        <TextField
          label="Rodapé / Observação legal (opcional)"
          value={v.disclaimer || ""}
          onChange={(e)=>set({ disclaimer: e.target.value })}
          fullWidth multiline minRows={2}
        />
      </div>
    </Box>
  );
};

export default TermsEditor;
